import WelcomeCallInformationHeader from './WelcomeCallInformationHeader'

export default WelcomeCallInformationHeader
